<template>
  <div>
    <div class="container md:w-11/12 lg:w-11/12 md:my-10 px-2 py-0">
      <h1 class="mb-5 text-slate font-sans lg:text-4xl sm:text-text-2xl italic hidden">
        I'm <span class="text-hugo"> HUGO</span>. Ask me anything
      </h1>

      <div
        id="container"
        style="overflow-y: auto"
        class="
          bg-white
          questionArea
          md:h-70
          lg:h-70
          h-96
          shadow
          p-3
          flex flex-col
          space-y-2
          overflow-y-auto
          scrollbar-thumb-blue
          scrollbar-thumb-rounded
          scrollbar-track-blue-lighter
          scrollbar-w-2
          scrolling-touch
          rounded-3xl
        "
      >
      <div v-if="loading">
        <div class="text-center">
    <div class="flex items-center">
    <div class="w-full">
        <div class="max-w-sm rounded overflow-hidden animate-pulse">
        <div class="px-6 py-4">
            <div class="h-6 bg-gray-300 mb-2"></div>
            <div class="h-4 bg-gray-300 w-2/3"></div>
        </div>
        <div class="px-6 pt-4 pb-2">
            <div class="h-4 bg-gray-300 w-1/4 mb-2"></div>
            <div class="h-4 bg-gray-300 w-1/2"></div>
        </div>
        </div>
    </div>
</div>
</div>
      </div>
       <div
        v-if="!loading"
       >
         <div
          :id="`chat-message-${index}`"
          class="chat-message"
          v-for="(q, index) in conversation"
          :key="index"
        >
          <transition name="fade">
            <div v-if="q.sender === 'bot'" class="flex items-end">
              <div
                class="
                  flex flex-col
                  space-y-1
                  max-w-xs
                  mx-2
                  items-start
                "
              >
                <div>
                  <span
                    v-if="q.content"
                    v-html="q.content"
                    class="
                      mt-2
                      px-4
                      py-3
                      rounded-xl
                      inline-block
                      rounded-bl-none
                      bg-blue-200
                      text-gray-800
                    "
                  ></span>
                </div>
                <button
                  @click="buttonClick(q.button)"
                  v-if="q.button != ''"
                  class="
                    hugo-purple
                    hover:bg-yellow-200
                    hover:text-purple-800
                    text-white
                    font-semibold
                    hover:text-white
                    py-3
                    px-6
                    border border-purple-800
                    hover:border-transparent
                    rounded-3xl
                    mt-2
                  "
                >
                  {{ q.button }}
                </button>
              </div>
            </div>
          </transition>
          <div v-if="q.sender === 'user'" class="flex items-end justify-end">
            <div
              class="
                flex flex-col
                space-y-2
                max-w-xs
                mx-2
                order-1
                items-end
              "
            >
              <div>
                <span
                  v-html="q.content"
                  class="
                    mt-2
                    px-4
                    py-3
                    rounded-lg
                    inline-block
                    rounded-br-none
                    bg-yellow-200
                    text-gray-600
                  "
                ></span>
              </div>
            </div>
          </div>


        </div>
        </div>

      </div>
      <div class="relative flex w-full flex-wrap items-stretch mb-2 my-5 pt-3">
        <input
          v-model="question"
          type="text"
          placeholder="Ask me anything..."
          class="
            px-3
            py-4
            mb-3
            shadow-md
            border-none
            focus:ring-transparent
            rounded-xl
            text-purple-800
            w-full
            pr-10
          "
        />
        <span
          v-on:keyup.enter="getQuestion"
          @click="getQuestion"
          class="
            mt-2
            transform
            rotate-45
            z-5
            h-full
            leading-snug
            font-normal
            absolute
            text-center text-blueGray-300
            absolute
            bg-transparent
            rounded-xl
            text-base
            items-center
            justify-center
            w-8
            right-8
            mb-4
          "
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6 rotate-90"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1"
              d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
            />
          </svg>
        </span>
        <transition name="fade">
          <div v-if="thinking" class="wrapper">
            <div class="bubble">
              <div class="bubble__circle"></div>
              <div class="bubble__circle"></div>
              <div class="bubble__circle"></div>
            </div>
          </div>
        </transition>
      </div>
    </div>

     <div class="text-left mt-1">
         <h4 class="text-white mb-3 ml-4">Trending Questions:</h4>
            <button @click="buttonClick('What is winter cashback?')" class="px-4 py-3 mx-2 md:text-base text-sm font-normal text-white bg-trending-button rounded-3xl mt-1">What is Winter Cashback?</button>
            <button @click="buttonClick('How do I opt in/opt out of Winter Cashback?')" class="px-4 py-3 mx-2 font-normal text-white bg-trending-button rounded-3xl md:text-base text-sm md:mt-1 mt-3">How do I opt in/opt out of Winter Cashback?</button>
      </div>

    <div
      v-if="suggestAnswerModal"
      class="fixed z-10 inset-0 overflow-y-auto"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div
        class="
          flex
          items-end
          justify-center
          min-h-screen
          pt-4
          px-4
          pb-20
          text-center
          sm:block sm:p-0
        "
      >
        <!--
      Background overlay, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0"
        To: "opacity-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100"
        To: "opacity-0"
    -->
        <div
          class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          aria-hidden="true"
        ></div>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span
          class="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
          >&#8203;</span
        >

        <!--
      Modal panel, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        To: "opacity-100 translate-y-0 sm:scale-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100 translate-y-0 sm:scale-100"
        To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    -->
        <div
          class="
            inline-block
            align-bottom
            bg-white
            rounded-lg
            text-left
            overflow-hidden
            shadow-xl
            transform
            transition-all
            sm:my-8 sm:align-middle sm:max-w-lg sm:w-full
          "
        >
          <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <form>
              <div>
              <h2 class="mt-3 mb-3 text-xl border-b-2 pb-2">Ask your answer.</h2>

              </div>
              <div class="mb-6">
                <label
                  for="name"
                  class="
                    block
                    mb-2
                    text-sm
                    font-medium
                    text-gray-900
                    dark:text-gray-300
                  "
                  >Your Name</label
                >
                <input
                  type="text"
                  id="name"
                  class="
                    bg-gray-50
                    border border-gray-300
                    text-gray-900 text-sm
                    rounded-lg
                    focus:ring-purple-500 focus:border-purple-500
                    block
                    w-full
                    p-2.5
                    dark:bg-gray-700
                    dark:border-gray-600
                    dark:placeholder-gray-400
                    dark:text-white
                    dark:focus:ring-blue-500
                    dark:focus:border-blue-500
                  "
                  placeholder="Your Name"
                  required
                />
              </div>
              <div class="mb-6">
                <label
                  for="email"
                  class="
                    block
                    mb-2
                    text-sm
                    font-medium
                    text-gray-900
                    dark:text-gray-300
                  "
                  >Your email</label
                >
                <input
                  type="email"
                  id="email"
                  class="
                    bg-gray-50
                    border border-gray-300
                    text-gray-900 text-sm
                    rounded-lg
                    focus:ring-purple-500 focus:border-purple-500
                    block
                    w-full
                    p-2.5
                    dark:bg-gray-700
                    dark:border-gray-600
                    dark:placeholder-gray-400
                    dark:text-white
                    dark:focus:ring-blue-500
                    dark:focus:border-blue-500
                  "
                  placeholder="bot@hugoenergyapp.co.uk"
                  required
                />
              </div>

              <div class="mb-6">
               <label for="answer" class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-400">Question</label>
<textarea id="answer" rows="4" class="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Leave a answer..."></textarea>
              </div>
            </form>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <button
              @click="suggestAnswerModal = false"
              type="button"
              class="
                mt-3
                w-full
                inline-flex
                justify-center
                rounded-md
                border border-gray-300
                shadow-sm
                px-4
                py-2
                bg-purple-700
                text-base
                font-medium
                text-white
                hover:bg-gray-50
                hover:text-gray-600
                focus:outline-none
                focus:ring-2
                focus:ring-offset-2
                focus:ring-indigo-500
                sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm
              "
            >
              Submit
            </button>
             <button
              @click="suggestAnswerModal = false"
              type="button"
              class="
                mt-3
                w-full
                inline-flex
                justify-center
                rounded-md
                border border-gray-300
                shadow-sm
                px-4
                py-2
                bg-white
                text-base
                font-medium
                text-gray-700
                hover:bg-gray-50
                focus:outline-none
                focus:ring-2
                focus:ring-offset-2
                focus:ring-indigo-500
                sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm
              "
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: "ChatBot",
  data() {
    return {
      question: "",
      loading: false,
      thinking: false,
      lookingFor: false,
      notFoundFlag: false,
      suggestAnswerModal: false,
      priceChart: true,
      currentQuestions:[],
      conversation: [
        {
          sender: "bot",
          content:
            "Hey I'm HUGO, Your Virtual Assistant!<br><br>Ask me a question or click the button below for help to get started.",
          button: "Get Started",
        },
      ],
      // answers:[],
      answers: [
        {
          keyword: ["Get Started"],
          question: "Get Started",
          shots: [
            'You can say things like: <br> - "Can I edit the Off Peak Hours?" <br> - "What is winter cashback?"',
            "💡 For the best results, <br> 1. Keep it short and simple <br> 2. Get straight to the point <br> 3. Rephrase your question if you didn't get the answer you were expecting.",
          ],
        },
        {
          keyword: ["hello"],
          question: "Hello",
          shots: [
            "Hey, I'm HUGO, Your Virtual Assistant! <br> <br> Ask me a question or click the button below for help to get started.",
          ],
        },
          {
    keyword: ["BUDGET", "PRO-RATA" , "PROJECTED"],
    question: "BUDGET SECTION: what does PRO-RATA and PROJECTED mean?",
    shots: ["So PRO-RATA means the amount you should have spent against your BUDGET for the month on the given date. So if for May 2022 I have a budget of £31 for electricity for the month by 15th May I should have spend £15 on a PRO-RATA basis. The white PRO-RATA line shows where you should be on the 15th May. So on 15th May if you have spend £13 the app will show you under the PRO-RATA budget and the bar colour will be green. If you're at £17 on 15th May you are over the PRO-RATA target and the bar colour is warning red. The PROJECTION button is basically what you will spend if you carry on at the same rate for the month. So again if you spent £17 by the 15th May your PROJECTION will be £35.12 against a target of £31. So the projection is designed to keep you on spending track."],
  },
  {
    keyword: ["off-peak", "tariff" , "edit"],
    question: "Can I edit the Off Peak Hours?",
    shots:
    [ "Yes if you go to the BUDGET section you will see a button that says EDIT TARIFF. Press this button and choose 'Input my tariff'. From here you can choose Single Rate or Day Night Rate tariff. By selecting the Day/Night tariff you can see a box that says 'Time Range'. Press this and you can adjust the Night time range to any period you wish. So 1230am to 430am or whatever matches your tariff at home. Update the standing charges and Day/Night tariffs and now HUGO can predict your costs accurately.",],
  },
  {
    keyword: ["multi-select" , "Chart" , "gas" , "electric"],
    question: "Can I multi-select time periods?",
    shots: [
      "Yes - If you go to the USAGE page you will see a toggle bar called 'Multi-select'. Click this toggle and the Chart will flip horizontal ! It gets even better, now you can select periods on the chart to see what the costs of that selected period are! If you have an electric car and want to see what a single charge has cost you, then you will love this.",
    ],
  },
  {
    keyword: ["gas", "electric"],
    question: "Can I turn off the Gas or Electric?",
    shots: [
      "Yes many HUGO users don't have gas and some don't have their electricity smart metered. So rather than see redundant functions for Gas/Elec you can turn off the fuel you don't have completely. Go to PROFILE ICON (top right corner) > MANAGE METER > ADDRESS. Then just toggle off the fuel that you don't use and by magic it was like it never existed!",
    ],
  },
  {
    keyword: ["credit" , "card" , "debit" , "sign", "up", "stripe" , "address" , "verify" , "HUGO"],
    question: "Why does HUGO need my credit/debit card details for sign up?",
    shots: [
      "Since we need to access your smart meter data (which is private to you and your household) we need to verify that you are linked to the address. The only automated and reliable way to do this is by verifying that you have a debit/credit card that is registered at your address. When you enter your debit/credit card details they immediately get encrypted and sent to STRIPE <a href=\"https://stripe.com/docs/security/stripe\"> https://stripe.com/docs/security/stripe</a> . STRIPE are one of the world's leading payment processors. STRIPE will only use the data to verify your card and address are linked. Once this is confirmed we can verify that the correct person is trying to access their own smart meter data. Your card details remain encrypted and secure at all times. HUGO cannot and will NOT use this process to levy any charges ever.",
    ],
  },
  {
    keyword: ["IHD", "display"],
    question: "How to sign up with your smart meter display (IHD/GUID)?",
    shots: [
      "Whilst our credit card sign up process is secure and encrypted we understand some people prefer not to sign up this way. We also can't sign up some customers using their card details if their MPAN and address don't match the network's database. As an alternative you can sign up using your In Home Display's (IHD/GUID) unique bar code - it can be tricky so we've created an explainer video you can watch on the VIDEOS web page.",
    ],
  },
  {
    keyword: ["historical" , "data", "recover"],
    question: "I'm seeing gaps in my historical data",
    shots: [
      "This can happen especially with older meters. However, our team is good at recovering missing data. So if you find a gap let us know and we will send out a recovery mission to cyber space.",
    ],
  },
  {
    keyword: ["costs" , "energy" , "bill" , "tariff", "gas" , "electric" , "switching" , "auto"],
    question: "Why We hate AUTO SWITCHING?",
    shots: [
      "Hi, my name is Ben Dhesi, I'm one of the Founders of HUGO.   I started life as a solicitor and then decided I wanted to be an entrepreneur - which lets face it, is far more exciting.   So I started an energy consultancy in 2009 which got the best energy deals for businesses.  The industry back then , and sadly still,  has plenty of cowboys looking to do deals for themselves rather than provide a great service for the client.  This was short sighted and I created a business based on the principles of providing a professional service, best advice and getting the best deal for the client - even if it meant less commission for me.   This model I think was hugely successful for me and led to numerous awards including Energy Buyer of the Year at the Energy Awards in 2015 and 2017 and Energy Technology Innovation of the Year 2016.  These principles were recognised when I sold Pulse Business Energy Ltd <a href=\"https://pulsebusinessenergy.co.uk \"> https://pulsebusinessenergy.co.uk </a> in 2018. Upon selling Pulse I embarked on a new journey - HUGO.  The aim was to use smart meter technology to actually provide the client with a useful product in the form of an APP - through which they could engage and manage their household energy usage.  So one aspect of the service I researched was AUTO SWITCHING.   Without boring you I quickly realised the only parties AUTO SWITCHING benefited was the incoming supplier and the Auto Switcher.   Say you have 100 suppliers, Auto Switchers can only go to maybe 5 or less because most suppliers reject them.   Secondly those suppliers are the ones prepared to pay big commissions to the the Auto Switcher and finally those suppliers are probably not offering great deals but are simply the best of a small pack of suppliers desperate to grab some quick new business. So when setting up HUGO it was an easy decision to REJECT auto switching because: THE CUSTOMER OUTCOME IS POOR! So the HUGO ENERGY APP will never auto switch you.   Yes you can switch via HUGO (when wholesale prices come back down)  but you can see all the tariffs available in the market via HUGO and we don't pressure you to switch, we just want to give you all the right info so YOU can make the best possible decision and have the easiest switching experience possible.  If we can do that, we think success will follow in the long term..",
    ],
  },
  {
    keyword: ["costs" , "energy" , "bill" , "tariff", "gas" , "electric"],
    question: "Can HUGO acccurately calculate my energy costs?",
    shots: [
      "Yes, because we are constantly benchmarking your Gas and Electricity costs against the market average tariff. However, to get the most billing and budget accuracy we recommend that you input your actual Electricity and Gas unit rate and standing charge by going to: BUDGET>EDIT TARIFF>INPUT MY TARIFF. Here you can also input your Electricity and/or Gas Tariff End dates - So HUGO will alert you when your tariff is coming to end.",
    ],
  },
  {
    keyword: ["HUGO" , "energy" , "data" , "meter", "gas" , "electric" , "smart"],
    question: "How does HUGO get my data?",
    shots: [
      "We require you to pass a verification process to prove that you are linked to the address. This is done by submitting a credit/debit card that is registered to your address, or entering the serial number from your IHD device. We also require you to consent to allowing us to access your data on your behalf. We then send this consent to the smart data collector's (DCC) approved partner and receive the data which we can then display on the HUGO ENERGY APP. Please see HUGO Privacy Policy for more information",
    ],
  },
  {
    keyword: ["HUGO" , "energy" , "data" , "friends", "family" , "login", "share"],
    question: "Can I share HUGO with friends and family?",
    shots: [
      "Yes absolutely. You can share the APP using the share icon that appears on every page of the APP.You can also share your household meter details with members of your household. You can do this via the Family Members section go to: My Settings>Manage Meter>Select Address>Family Members. From here you can share your household HUGO via Email or via Mobile - by sending them a unique Family Code. Get everyone in the home involved !.",
    ],
  },
  {
    keyword: ["SMETS" , "smart" , "meters" , "data", "gas" , "electric"],
    question: "Does HUGO work with SMETS 1 Smart meters?",
    shots: [
      "A big portion of SMETS 1 meters have been adopted by the network so yes it does - when you sign up to the APP we will tell you if the SMETS 1 meter works with the APP. But another easy way to check if your SMETS 1 meter is compatible is by entering your MPAN or MPRN into this Citizens Advice Bureau Smart meter checker database: <a href=\" https://smartmetercheck.citizensadvice.org.uk/ \" > https://smartmetercheck.citizensadvice.org.uk/ </a> ",
    ],
  },
      {
      keyword: ["winter", "cashback" , "cash" , "reduce"],
      question: "What is winter cashback?",
      shots: ["There’ll be upwards of five events where you’ll need to try and use less power, between November 22 and March 23. If you’re able to reduce your energy use under your normal amount - you’ll get a monetary credit which you will able to view and cash out within the Hugo Energy app at the end of the winter. Before each event, we’ll send you a notification via APP Notification email, or SMS.All you need to do is turn down as much as you can, and we’ll use the data from your smart meter to calculate the rest. You will need to reduce a minimum of 25% on your average usage for the event."],
    },
    {
      keyword: ["calculate", "usage" , "winter", "cashback"],
      question: "How will we calculate your winter cashback?",
      shots:
      [ "We'll work out what you typically use during the Demand Event time slot based on your historical smart meter readings, and calculate how much you reduced this by against your normal level. The grid will expect a minimum 25% reduction against your normal usage for the cashback to be activated.",],
    },
    {
      keyword: ["credit" , "winter" , "cashback" , "paid"],
      question: "How will I be paid and where can I see my credit?",
      shots: [
        "We’ll use the readings from your smart meter to calculate your Winter Cashback during the event window and then you can cash-in at the end of the Winter Cashback period (31st March 2023). Unfortunately due to the volume of data we won’t be able to assess individual meters and the cashback decisions are final. The credit will be shown in the CO2 section of the app – here you can also choose to donate your credit to offset your carbon emissions or allow the Cashback to accumulate and payout the amount at the end of winter and for payout please setup up a PayPal account to receive payments.",
      ],
    },
    {
      keyword: ["opt-in", "opt" , "winter" ,"cashback"],
      question: "How do I opt in/opt out of Winter Cashback?",
      shots: [
        "24 hours before each event you will be sent an APP notification and/or email/SMS asking if you want to opt into the Winter Cashback scheme. You will then need to turn on the 'Winter Cashback' toggle button in the settings to participate. If you don’t wish to participate you don’t need to do anything and you can ignore the message(s).",
      ],
    },
    {
      keyword: ["winter" , "cashback" , "energy" , "payment", "tariff", "provider" , "supplier"],
      question: "Will Winter Cashback this affect my energy tariffs or payment?",
      shots: [
        "No, neither will be affected. You’ll be charged for energy as normal from your energy provider throughout the Winter Cashback. If you opt in on another scheme similar to this with your supplier then we would advice you not to opt into the HUGO scheme aswell.",
      ],
    },
    {
      keyword: ["meter", "readings" , "manual", "manually"],
      question: "Do I have to take meter readings manually to take part?",
      shots: [
        "No – but you need a working smart meter for this trial, which means we can take the meter readings automatically to calculate what you’ve used. All you need to is to focus on finding ways to turn down your energy use during the power-down period. If your electricity data is not working during this period then you won’t be able to participate.",
      ],
    },
    {
      keyword: ["power" , "down", "penalised", "turn", "winter", "cashback"],
      question: "Do I get penalised if I can't turn things down/off?",
      shots: [
        "No - remember you don’t get penalised for not turning things down. You can also choose which Demand Events you want to be part of. So you don’t have to power down for every event. Just choose the events that are practical for you.",
      ],
    },
    {
      keyword: ["appliances" , "electrical" , "turn" , "off", "electric", "winter", "cashback"],
      question: "which appliances should I turn down?",
      shots: [
        "Any appliances that use a lot of electricity would be useful to not use during these events and will reduce your normal demand profile such as:        1. Washing machines 2. Dishwashers        3. Irons 4. Electric cars 5. Tumble Dryers 6. TVs . However, please don’t turn off anything that is critical to your wellbeing and safety. Any questions please email us at support@hugoenergyapp.co.uk'",
      ],
    },
      {
      keyword: ["data", "can't" , "showing" , "see" , "not",],
      question: "Why can't I see my data?",
      shots: ["The data can take between 30 minutes and 24 hours to come through on the first occasion. We will keep an eye on this for you and if the data doesn't arrive within 24 hours HUGO will send a team to cyber space 🚀 to try and recover it for you.  Mission update shortly."],
    },
    {
      keyword: ["real", "time" , "data", ],
      question: "Can HUGO show real time data??",
      shots:
      [ "The simple answer is no.   Even our competitor APPs (whose name we won’t mention) can only access data every 2 hours at best. This is the most anyone can do over the cloud currently.   So, if you think you’re looking at real time data the best you’re doing is looking at data up to two hours behind real time, and more than often your data is often around 4 – 8 hours behind. <br> Why not show two hour delayed data? <br> We decided that there was little merit in showing delayed same day data as this would lead to a poor user experience when you first open HUGO, and we think real-time data is overrated. <br> Real-time data is a product that we’ve been sold for the past ten years with the advent of smart meters,  However, the energy industry completely missed a trick here.  Thinking that people would be obsessed with turning on a kettle and then running to their display to see how much electricity it uses, is simply not what people do.  This is also of limited value because real savings comes through understanding your energy patterns and behaviour change. <br> One of the most effective ways of using smart meter data is to view your daily usage pattern.  For example, below is a screenshot of a user’s daily gas usage profile when they first installed HUGO and next to it is their daily gas usage profile after they realised how much it could be reduced over the summer.  A typical daily profile usually does not change, so understanding it and how to optimise it is where the data can be really useful.",],
    },
    {
      keyword: ["input" , "tariff" , "budget" , "usage"],
      question: "How do I input tariffs to set my budget?",
      shots: [
        "Make sure you input your tariff and standing charges and set an end date in the future (preferably when your contract ends).  Otherwise all the data in HUGO will default to the energy price cap and if your not paying this the data won’t be accurate in the USAGE, BUDGET or TARIFFS section.",
      ],
    },
    {
      keyword: ["budget", "target" , "set" ,"tariff", "graph", "projected", "electric", "gas"],
      question: "How do I set a budget target?",
      shots: [
        "Work out what you want to pay either daily, weekly, monthly and yearly for gas/electricity.  Then the BUDGET section will show you how your performing against this and you can view your performance on a daily, weekly, monthly yearly basis against this target. <br> TIP:  Reset the budget in the winter and summer as our usage patterns change seasonally.   Otherwise expect to be lower than your budget in summer and higher in the winter. <br> TIP: The GRAPH view can show you how your doing against the BUDGET switch between PRO-RATA and PROJECTED GRAPHS views to see which you prefer..",
      ],
    },
    {
      keyword: ["incorrect" , "wrong" , "energy" , "usage", "tariff" ,"data" , "calculation"],
      question: "My usage/budget or data/calculation is wrong?",
      shots: [
        "This issue is commonly caused by duplicate and overlapping tariff periods saved in the APP.  Please go to BUDGET > EDIT TARIFF section.   Here you can see all the tariffs saved against your meter.   If you delete any overlapping and duplicate tariffs this should solve the issue going forward. <br> With the recent update you can see your current and historical tariffs info. We also added code to prevent you from saving overlapping tariffs in the future.  Once deleted refresh the app. <br> If this doesn't work please don't hesitate to get in touch with support@hugoenergyapp.co.uk.",
      ],
    },
    {
      keyword: ["meter", "smart" , "MPAN", "supplier", "find"],
      question: "HUGO can't find my smart meter?",
      shots: [
        "Thanks for trying to download the HUGO APP.   Unfortunately, your MPAN is not connected to the smart meter network so we couldn’t connect to it. <br> You can check your MPAN status on the citizen’s advice bureau website <a href=\" https://smartmetercheck.citizensadvice.org.uk/ \"> https://smartmetercheck.citizensadvice.org.uk/ </a> <br> This also means suppliers can’t view the data either and probably still rely on estimated readings.   Suppliers have a duty to upgrade these to the network so I would raise this with your supplier and get a free upgrade…...don’t worry HUGO will still be waiting for you! <br> Otherwise from the HUGO team - thanks for trying",
      ],
    },
    {
      keyword: ["projected" , "switch" , "show" , "budget", "electric", "track", "spend", "projection"],
      question: "Budget: When I switch to projected what does this show?",
      shots: [
        "In the main BUDGET section the PROJECTION button is basically what you will spend if you carry on at the same rate for the week, month or year. So again if I spent £17 by the 15th May and then switch to PROJECTION view your PROJECTION will be £35.12.  If my  target is £31 I’ll need to reduce usage the rest of the month to get back within my target by the end of the month. So the projection is designed to keep your spending on track.",
      ],
    },
    {
        keyword: ["seasonal" , "average", "button", "budget", "show", "temperature"],
        question: "What does the seasonal average button show?",
        shots: [
          "If you set a budget of £1,200 per annum for gas your budget is £100 per month.   Based on the average seasonal temperatures for each month of the year we know that actually you should only spend 4% of this budget is June and 16% in January (as examples).   So the seasonal average adjusts the BUDGET data to show you if you are above or under BUDGET based on historical seasonal averages.  This section also keeps a record of what you have spent historically each month.",
        ],
      },
      {
        keyword: ["pro-rata" , "pro", "rata", "budget", "usage", "electric"],
        question: "What does pro-rata mean?",
        shots: [
          "So on the main BUDGET screen PRO-RATA means the amount you should have spent against your BUDGET for the month on a given date. So if in May 2022, I have a total budget of £31 for electricity, by 15th May I should have spend £15 on a PRO-RATA basis. The white PRO-RATA line shows where you should be on the 15th May. So on 15th May if you have spent £13 the app will show you under the PRO-RATA budget and the bar colour will be green. If your at £17 on 15th May you are over the PRO-RATA target and the bar colour is red.  So green is good and red is a warning sign.",
        ],
      },
      {
      keyword: ["tariffs", "cost" , "calculator" , "supplier" , "bill", "provider"],
      question: "Why can't I see my data?",
      shots: ["When generating bill via HUGO using the COST CALCULATOR and check the following against your supplier bill: <br> 1. Billing dates match exactly. <br> 2. The tariff matches exactly (unit rate and standing charges) and time periods for the tariffs match the bill <br> 3. The usage matches <br> If the usage is not a match, please check the supplier bill contains no estimated readings. <br> If HUGO is showing less usage and there are no estimated readings, we may have some gaps in your data for this period and please message us and we will try to fill these gaps. <br> Disclaimer:   Please note HUGO generated bills are an estimate to assist you to manage your energy usage and costs.  Every effort has been made to provide information that is current and accurate. Nevertheless, inadvertent errors in information may occur.    HUGO can provide no assurance or warranty that information in the app is current and accurate and take no responsibility for matters arising from gaps or missing data."],
    },
    {
      keyword: ["real", "time" , "data", "live" ],
      question: "Why doesn't HUGO show live data?",
      shots:
      [ "The live data is not possible over the cloud.  So, we show the last 24 hours as a first point of call. <br> Please see our BLOG about live data here: <b> <a href=\"https://hugoenergyapp.co.uk/the-real-time-data-myth/\"> https://hugoenergyapp.co.uk/the-real-time-data-myth/ </a> </b> <br> We will be releasing a same day button in the future, but this will still have an up to 2 hour lag.",],
    },
    {
      keyword: ["terms" , "conditions" ,],
      question: "Where can I view Terms and Conditions?",
      shots: [
        "Click on top right toggle for SETTINGS then you can click on TERMS AND CONDITIONS to view.",
      ],
    },
    {
      keyword: ["change", "address" , "MPAN" ,"see", "view", "home"],
      question: "How do I view my address/MPAN?",
      shots: [
        "Click on top right toggle for SETTINGS then you can click on MANAGE METER to see your address and MPAN",
      ],
    },
    {
      keyword: ["change" , "gas" , "energy" , "electric", "supplier" ,"provider"],
      question: "How do I change my gas or electric supplier in the app?",
      shots: [
        "Click on top right toggle for SETTINGS then you can click on MANAGE METER > then you can see your current gas/electric supplier - Click on the dropdown menu to then change your energy supplier",
      ],
    },
    {
      keyword: ["home", "EPC" , "view", "see", "certificate", "rating", "energy"],
      question: "How can I view my EPC certificate?",
      shots: [
        "Click on top right toggle for SETTINGS then you can click on MANAGE METER > then scroll down to the bottom where you can click on 'view EPC certificate' and your energy rating for your home",
      ],
    },
    {
      keyword: ["delete" , "account", "HUGO", "profile",],
      question: "How do I delete my HUGO account?",
      shots: [
        "We will be sorry to see you leave.... To delete your account click on top right toggle for SETTINGS then you can click on MANAGE METER > then you will see the option to 'delete account'",
      ],
    },
    {
      keyword: ["gas" , "switch" , "off" , "electricity", "electric", "turn",],
      question: "How do I switch off my gas or electricity in HUGO?",
      shots: [
        "Click on top right toggle for SETTINGS then you can click on MANAGE METER > then you can toggle off either your gas or electric in HUGO",
      ],
    },
    {
        keyword: ["change" , "password",],
        question: "How do I change my password?",
        shots: [
          "Click on top right toggle for SETTINGS then click SECURITY you will then be asked to enter your current password and then to enter our new password twice.",
        ],
      },
       {
      keyword: ["winter", "cashback" , "registration"],
      question: "What is Winter Cashback registration?",
      shots: ["We have been advised by National Grid for future scheme compliance the app must have, not one, but two Winter Cashback toggle buttons: <br> One button for you to register to the Winter Cashback scheme (you only need to do this once). <br> A second button to Opt-In to each Hugo Winter Cashback event. <br> You must register before each Thursday of the week in order to qualify to opt-in to a Winter Cashback event of the following week. <br> Whilst we would rather keep the existing app experience, this is a regulatory requirement"],
    },
    {
      keyword: ["carbon", "offset" , "CO2", "renewable" ],
      question: "What is the Carbon Offset scheme?",
      shots:
      [ "We work with the leading carbon offset providers in the UK and globally. We aim to offer the best carbon offset programs in the UK and enable anyone worldwide to easily join a carbon offset program. By offsetting carbon emissions you can live a carbon neutral life. We only use certified carbon offset projects and carbon offset companies in the UK and globally. Purchase an offset from one of our carbon offset scheme and we will send you a certificate by email.",],
    },
    {
      keyword: ["landscape" , "usage", "multi", "select", "toggle" ,],
      question: "How do I make my usage landscape view?",
      shots: [
        "When you are on the usage tab, you should see multi-select toggle button towards the top of the screen. Click this on and landscape view will be shown for your usage.",
      ],
    },
    {
      keyword: ["tip", "energy" , "saving" ,"efficient", "tips", "home"],
      question: "What is the tips section on HUGO?",
      shots: [
        "Want to help the HUGO community? Go on to the tips tab in the App and click 'create tip' towards the bottom of the screen and enter an energy saving tip that has helped you and would help others. <br> Are you looking for energy saving tips? Here, you can also find tips from the HUGO community to help you lower energy usage in your home.",
      ],
    },
    {
      keyword: ["change" , "gas" , "energy" , "electric", "supplier" ,"provider"],
      question: "How do I change my gas or electric supplier in the app?",
      shots: [
        "Click on top right toggle for SETTINGS then you can click on MANAGE METER > then you can see your current gas/electric supplier - Click on the dropdown menu to then change your energy supplier",
      ],
    },
    {
      keyword: ["change", "£" , "pounds", "see", "kWh", "energy", "usage", "budget"],
      question: "How do I change my budget or usage from £ pounds to kWh?",
      shots: [
        "When you are either on the budget or usage tab, you will see on the top left corner you will see a toggle to change £ and kWh. You can slide the toggle either way, whether you want to see £ or kWh.",
      ],
    },
     {
      keyword: ["bills", "billing" , "match", "period", "cost", "calculator", "supplier", "provider", "bill", "create" ],
      question: "How to match/create my billing period in HUGO?",
      shots: ['To make an accurate comparison you can generate a bill via HUGO using the COST CALCULATOR and check the following against your bill: Billing dates match exactly; <br> 1. Delete any overlapping tariff in the BUDGET > EDIT TARIFF section (as this effects the calculations) <br> 2.The tariff matches exactly (unit rate and standing charges) and time periods for the tariffs match the bill <br> 3. The usage matches. <br> If the usage is not a match please check the supplier bill contains no estimated readings. If HUGO is showing less usage and there are no estimated readings we may have some gaps in your data for this period and please message us and we will try to fill these gaps. <br> Please note HUGO generated bills are an estimate to assist you to manage your energy usage and costs.  Every effort has been made to provide information that is current and accurate. Nevertheless, inadvertent errors in information may occur. HUGO can provide no assurance or warranty that information in the app is current and accurate, and take no responsibility for matters arising from gaps or missing data. <br> Want to beat the Governments energy price cap and make saving on other bills?  '],
    },
    {
      keyword: ["smart", "meter" , "can't", "find", "not", "found", "network" ],
      question: "Why can't HUGO find my smart meter?",
      shots:
      [ "Thanks for trying to download the HUGO APP.   Unfortunately, your MPAN is not connected to the smart meter network so we couldn’t connect to it. <br> You can check your MPAN status on the citizen’s advice bureau website<b> <a href=\"https://smartmetercheck.citizensadvice.org.uk/\"> https://smartmetercheck.citizensadvice.org.uk/ </a> </b> <br> This also means suppliers can’t view the data either and probably still rely on estimated readings. Suppliers have a duty to upgrade these to the network so I would raise this with your supplier and get a free upgrade. When they fix it let us know and HUGO will send out another recovery team straight away 🚀 <br> Finally, if your supplier doesn't think there is an issue or show no signs of wanting to resolve it",],
    },
    {
      keyword: ["EPC", "wrong" , "showing" , "see" , "not", "certificate", "incorrect"],
      question: "My EPC certificate is wrong?",
      shots: ["We access this from the government's EPC certificate website directly. So if there is a fault with the EPC certificate it means there is a filing error on the national EPC database. <br> dluhc.digital-services@levellingup.gov.uk <br> Telephone: 020 3829 0748 <br> Monday to Friday, 9am to 5pm"],
    },
    {
      keyword: ["£" , "kwh" , "budget" , "usage", "money",],
      question: "Can you set up kWh or £ BUDGETS?",
      shots: [
        "You can set up BUDGETS for both £ and kWH. If you change the toggle switch in the top left hand corner of the budget or usage tab, you will be able to adjust your BUDGET.",
      ],
    },
    {
      keyword: ["graph" , "view" , "budget" , "projected", "money",],
      question: "Can I see graph view of my budget?",
      shots: [
        "Yes you can! Toggle top right of the screen under the BUDGET tab. The GRAPH view can show you how your doing against the BUDGET switch between PRO-RATA and PROJECTED GRAPHS views to see which you prefer."
      ],
    },
    {
      keyword: ["email" , "change" , "wrong" , "incorrect",],
      question: "How do I change my email address?",
      shots: [
        "Please send message within the app by pressing help icon ! at top of the page and select subject - Other Issue /Feedback and then specify the email you would like it to be changed to. Once done press send and we will be able to change it over.",
      ],
    },
    {
      keyword: ["property" , "bedrooms" , "insulation" , "heat", "house", "home",  "details",],
      question: "How do I enter my property details?",
      shots: [
        "Click on top right toggle for SETTINGS then you can click on MANAGE METER > click on property details and here you will be able to enter No. of bedrooms, No. of occupants, whether it is a house or flat, rate your insulation from good, average or bad and how do you heat and cook your home. Then select save changes once you're done. This information is great for the future of HUGO where we will be able to utilize this to help you as a customer.",
      ],
    },
    {
        keyword: ["VAT" , "show" , "include" , "exclude", "budget", "usage",  "calculate",],
        question: "Does the budget include my VAT?",
        shots: [
          "The VAT is automatically included in the BUDGET section of the app. If you want to exclude it then toggle off the VAT towards the bottom of the screen. <br> In the USAGE section of the app, it excludes the VAT and if you are viewing the cost and want to include VAT then you would need to turn on the VAT toggle towards the bottom of the page.",
        ],
      },
      {
        keyword: ["standing" , "show" , "include" , "exclude", "charge", "usage",  "calculate", "usage",],
        question: "Does the cost in the USAGE section include standing charge?",
        shots: [
          "The STANDING CHARGE is excluded in the USAGE section of the app. If you want to include it then toggle on the STANDING CHARGE towards the bottom of the screen. <br> In the BUDGET section of the app, it already include the STANDING CHARGE when you input your tariff.",
        ],
      },
      {
        keyword: ["share" , "app" , "friend" , "family",],
        question: "Is there a share option on HUGO?",
        shots: [
          "Yes there is! You can share with family or friends to spread the HUGO mission. Click the SHARE icon in the top right corner and get more members onboard.",
        ],
      },
      {
        keyword: ["alexa" , "setup"],
        question: "How do I set up Alexa ?",
        shots: [
          "Please read our Alexa set up guide here: <b><a href=\"https://hugoenergyapp.co.uk/hugo-x-alexa-set-up-guide/\"> https://hugoenergyapp.co.uk/hugo-x-alexa-set-up-guide/ </a></b>  ",
        ],
      },
      ],
    };
  },
  methods: {
    notFound() {
      this.thinking = true;
      setTimeout(() => {
        this.PushAnswer([
          "Sorry, I didn't find your concern question <br>",
        ]);
      }, 500);
      setTimeout(() => {
        this.PushAnswer([
          "Please ask your question to Experts in App."])
        this.PushAnswer(["Let's try that again..."]);
      }, 800);
      setTimeout(() => {
        this.thinking = false;
      }, 1200);
    },
    getQuestion: function () {
      if (this.question) {
        this.conversation.push({
          sender: "user",
          content: this.question,
          button: "",
        });
        this.FindAnswer(this.question);
        this.question = "";
      }
    },
    buttonClick: function (buttonValue) {
      this.currentQuestions = [];
      this.thinking = true;
      if (buttonValue == "Ask Question") {
        this.suggestAnswerModal = true;
      }
      else if (buttonValue == "Get Started") {
        setTimeout(() => {
          this.PushAnswer(["You can say things like:"]);
        }, 500);
        setTimeout(() => {
          this.PushButton("Can I edit the Off Peak Hours?");
        }, 1000);
        setTimeout(() => {
          this.PushButton("What is Winter Cashback?");
        }, 1500);
        setTimeout(() => {
          this.PushAnswer([
            "💡 For the best results, <br> 1. Keep it short and simple <br> 2. Get straight to the point <br> 3. Rephrase your question if you didn't get the answer you were expecting.",
          ]);
        }, 2500);

        setTimeout(() => {
          this.thinking = false;
        }, 3000);
      } else {

        this.conversation.push({
          sender: "user",
          content: buttonValue,
          button: "",
        });
        this.FindAnswer(buttonValue);
      }
    },
    FindAnswer: function (question) {
      let find = false;
      let f = this;

      this.answers.filter(function (item, i) {
        if (item.question.toLowerCase() == question.toLowerCase()) {
          f.thinking = true;
          setTimeout(
            () => {

              f.PushAnswer(item.shots);
              f.scrollToEnd();
            },
            i > 5 ? 5 * i : 10 * i
          );
          setTimeout(() => {
            f.thinking = false;
          }, 10 * i);
          find = true;
        }
      });
      if (!find) {
        this.notFoundFlag = false;

        // let arrayOfQuestion = question.split(" ");
           let arrayOfQuestion = question.replace(/[^a-zA-Z ]/g, "")
            arrayOfQuestion = arrayOfQuestion.split(" ");
        let itemsToBeRemoved = ["?", "what", "are", "is"];
        var cleanArray = arrayOfQuestion.filter(
          (element) =>
            !itemsToBeRemoved.some((item) =>
              element.toLowerCase().includes(item.toLowerCase())
            )
        );

        if (cleanArray.length > 0) {
          //  f.PushAnswer(["Are you looking for ?"])
          this.lookingFor = true;
        }

        cleanArray.filter(function (item, i) {
          setTimeout(() => {
            f.findInKeyWords(item.toLowerCase());
          }, 200 * i);
        });
      }
    },
    findInKeyWords(word) {
      // console.log('looking for ',word);
      let f = this;
      let find = false;
      f.thinking = true;

      f.answers.filter(function (item, index) {
       // console.log(item.keyword, index);
        if (item.keyword.includes(word)) {
          if (f.lookingFor) {
            find = true;
            f.PushAnswer(["Are you looking for ?"]);
            f.lookingFor = false;
            f.notFoundFlag = true;
          }
          setTimeout(
            () => {
              f.PushButton(item.question);
            },
            index > 5 ? 10 * index : 20 * index
          );
        }

        if (f.answers.length - 1 == index) {
          setTimeout(() => {
            f.thinking = false;
          }, 100);
        }

        if (!find && !f.notFoundFlag && f.answers.length - 1 == index) {
          f.notFound();
          f.notFoundFlag = true;
        }
      });

      f.scrollToEnd();
    },
    PushAnswer: function (shots) {

      shots.forEach((shot) => {
        setTimeout(() => {
        //  console.log('');
          this.conversation.push({
            sender: "bot",
            content: shot,
            button: "",
          });
        }, Math.floor(Math.random() * 0));
      });

      this.scrollToEnd();
    },
    PushButton: function (shot) {

      if (!this.currentQuestions.includes(shot)) {
            this.currentQuestions.push(shot);
            setTimeout(() => {
              this.conversation.push({
                sender: "bot",
                content: "",
                button: shot,
              });
            }, Math.floor(Math.random() * 0));

      }

      this.scrollToEnd();
    },
    scrollToEnd: function () {
      setTimeout(() => {
        var st = `#chat-message-${this.conversation.length - 1}`;
        // console.log('st',st);
        const el = this.$el.querySelector(st);
        // console.log('el',el);
        if (el) {
         // console.log(el);
          el.scrollIntoView({ behavior: "smooth", block: "end" });
        }

        // var container = this.$el.querySelector("#container");
        // console.log(container.scrollHeight);
        // console.log( 'height', container.scrollHeight+200);
        // container.scrollTop = container.scrollHeight + 100000;
        // container.scrollTo(100000, 100000);
      }, 100);

      // container.scrollTop = container.innerHeight + 10000;
    },
  },
  mounted() {

    window.addEventListener("keyup", (event) => {
      if (event.keyCode === 13) {
        this.getQuestion();
        this.scrollToEnd();
      }
    });
    this.scrollToEnd();
    this.priceChart = false;
  },
  beforeMount() {
    // Make your API call here
    this.loading = true;
    // axios.get('https://api.hugopro.xyz/bot/hugo_app')
    axios.get('https://api.hugoenergypro.co.uk/bot/hugo_app')
      .then(response => {
        // Handle the API response
       // this.responseData = response.data;

        console.log(response.data);

        response.data.length > 0 ? this.answers = response.data : ''
//        this.answers = response.data;
        this.loading = false;

      })
      .catch(error => {
        // Handle errors
      //  alert('error');
        console.error('Error fetching data:', error);
        this.loading = false;
      });
  },
};
</script>

<style scoped>
h1, h2, h3, h4, h5, h6 {
    font-size: revert !important;
    font-weight: revert !important;
}
</style>